<script>
import {
  GoogleMap,
  // CustomControl
  Marker,
  MarkerCluster,
  InfoWindow,
  // CustomMarker
  // Polygon
} from "vue3-google-map";


// import {EyeIcon, PhoneIcon} from "@zhuowenli/vue-feather-icons";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import flatPickr from "vue-flatpickr-component";
import axios from "axios";
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";
import notes from "@/components/users/notes.vue";
import moment from "moment/moment";
import SimpleTypeahead from "vue3-simple-typeahead";
// import econtacts from "@/components/clients/econtacts.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.scss";
import loader from "@/components/widgets/loader.vue";
import TrafficLightLegend from "@/components/TrafficLightLegend.vue";


/**
 * Google-map component
 */
export default {
  page: {
    title: "Google Map",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    SimpleTypeahead,
    // econtacts,
    // notes,
    flatPickr,
    Layout,
    PageHeader,
    GoogleMap,
    // CustomControl
    Marker,
    // Polygon
    MarkerCluster,
    // CustomMarker,
    Multiselect,
    InfoWindow,
    // EyeIcon,
    // PhoneIcon,
    notes,
    loader,
    TrafficLightLegend
  },
  data() {
    return {
      title: "Google Maps",
      items: [
        {
          text: "Maps",
          href: "/",
        },
        {
          text: "Google Maps",
          active: true,
        },
      ],
      itemsSearch: [],
      markers: [],
      notesData: [],
      statusList: {},
      typeList: {},
      center : null,
      clientData: {},
      departmentList: {},
      humanfriendlyConfig: {
        dateFormat: "F j, Y",
      },
      humanfriendlyConfigDates: {
        dateFormat: "F j, Y",
        altInput: true,
        altFormat: "F j, Y",
        allowInput: true,
      },
      searchValues: {
        visitStatus: '0',
        leadType: [],
        keyword: '',
        language: '3',
        isProspect: window.location.href.match('/prospects/') ? 1 : 0,
        status: '0',
        dateRange: '4',
        department: '0',
        postalCode: '',
        toDate: null,
        fromDate: null,
        // fromDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toLocaleDateString('en-us', { year:"numeric", month:"long", day:"numeric"}),
      },
      selectedMarker: null,
      infoBoxOpen: false,
      timeConfig: {
        enableTime: false,
        dateFormat: "d M, Y"
      },
      mapHeight: '600px',
      sortingStatus: [],
      sortingSource: [
        { value: '0', label: 'All' }
      ],
      sortingVisitStatus: [
        { value: '0', label: 'All' },
        { value: 'green', label: 'Visited Recently' },
        { value: 'yellow', label: 'Follow-up Needed' },
        { value: 'red', label: 'Overdue / Never' }
      ],
      isLoading: false,
      zoom: 15,
      didCenterOnce: false,
      selectedCluster: null,
      modalFormTitle: '',
    };
  },
  computed: {
    rawMarkers() {
      return this.markers.filter(x => !x.isCluster);
    },
    clusterMarkers() {
      return this.markers.filter(x => x.isCluster);
    }
  },
  methods: {
    getPinIcon(color) {
      const pinColor = color === 'green' ? '#198754' : (color === 'orange' ? '#fd7e14' : (color === 'yellow' ? '#f39c12' : '#d32f2f'));
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32">
          <path d="M12 0C5.37 0 0 5.37 0 12c0 9 12 20 12 20s12-11 12-20c0-6.63-5.37-12-12-12z" fill="${pinColor}"/>
          <circle cx="12" cy="12" r="4" fill="white" fill-opacity="0.4"/>
        </svg>
      `;
      const url = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
      // Once Google Maps is ready, return a full Icon so the source label sits
      // in a box floating just above the pin (labelOrigin), like the mock.
      if (window.google && window.google.maps) {
        return {
          url,
          scaledSize: new window.google.maps.Size(24, 32),
          anchor: new window.google.maps.Point(12, 32),
          labelOrigin: new window.google.maps.Point(12, -8),
        };
      }
      return url;
    },
    formatDate: function (date, format) {
      date = moment(date).format(format)
      return date;
    },
    viewUserGroup(request) {
      const currentRole = jwt_decode(localStorage.getItem('jwt'))
      return currentRole.userGroup.includes(request)
    },
    getCurrentLocation(highAccuracy = true) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            this.successCallback,
            (error) => {
               // If high accuracy GPS times out or is unavailable (common in old iOS), try again with low accuracy.
               if (highAccuracy && (error.code === 2 || error.code === 3)) {
                   console.warn("High accuracy geolocation failed or timed out. Falling back to low accuracy...");
                   this.getCurrentLocation(false);
               } else {
                   this.errorCallback(error);
               }
            },
            {
              enableHighAccuracy: highAccuracy,
              // Use a shorter timeout for the high-accuracy attempt, then longer for the fallback
              timeout: highAccuracy ? 7000 : 15000,
              maximumAge: highAccuracy ? 0 : 300000
            }
        )
      } else {
        console.warn("Geolocation is not supported by this browser.");
      }
    },
    successCallback(position) {
      if (this.didCenterOnce) return;

      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      this.center = { lat: latitude, lng: longitude };
      this.zoom = 15;
      this.didCenterOnce = true;

      const ref = this.$refs.mapRef;
      const map = ref && (ref.map || ref.$mapObject || ref.googleMap);
      if (map) {
        map.panTo(this.center);
        map.setZoom(15);
      }
    },
    async errorCallback(error) {
      console.warn("Geolocation error: ", error);
      let errorMsg = 'Could not get your current location.';
      if (error.code === 1) errorMsg = 'Location permission denied.';
      else if (error.code === 2) errorMsg = 'Location information is unavailable.';
      else if (error.code === 3) errorMsg = 'Location request timed out.';

      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      });
      Toast.fire({ icon: 'info', title: errorMsg });
    },
    async getClientInfo(id) {
      this.openCreate = 0;
      document.getElementById('edit-btn').style.display = 'block';
      document.getElementById('add-btn').style.display = 'none'
      this.modalFormTitle = this.searchValues.isProspect ? "Edit Prospect" : "Edit Client";

      const data = {
        token: localStorage.getItem('jwt'),
        ID: id
      }

      // document.getElementById('editNoteOpen').style.display='block';
      await this.getNotes(id)
      let clientInfo;

      await axios
          .post('/api/client/getClient', data)
          .then(response => {
            clientInfo = response.data;
            this.setClientData(response.data);
            localStorage.setItem('selectedUser', clientInfo.ID);
            localStorage.setItem('selectedUserName', clientInfo.firstName + ' ' + clientInfo.lastName);
            // this.getMapsLink()
          })
          .catch(error => {
            if (error.response) {

              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }

              Swal.fire("Oops!", "Something was wrong, please contact your SysAdmin.", "error")
            }
          })
    },
    async getNotes(id = localStorage.getItem('selectedUser'), name) {
      const data = {
        token: localStorage.getItem('jwt'),
        userID: localStorage.getItem('id'),
        agentID: id,
        clientID: id,
      }
      localStorage.setItem('selectedUserName', name)
      localStorage.setItem('selectedUser', id)

      let url = '';
      url = '/api/client/getClientNotes';

      await axios
          .post(url, data)
          .then(response => {
            this.notesData = response.data;
          })
          .catch(error => {
            if (error.response) {
              Swal.fire("Oops!", "Notes could not be loaded, please contact your SysAdmin.", "error")
            }
          })
    },
    setClientData(clientInfo) {

      this.clientData.ID = clientInfo.ID || clientInfo.id;
      this.clientData.email = clientInfo.email;
      this.clientData.status = clientInfo.status;
      this.clientData.firstName = clientInfo.firstName;
      this.clientData.lastName = clientInfo.lastName;
      this.clientData.language = clientInfo.language;
      this.clientData.phoneNumber = clientInfo.phoneNumber;
      this.clientData.gender = clientInfo.gender;
      this.clientData.address = clientInfo.address;
      this.clientData.birthday = this.formatDate(clientInfo.dateOfBirth, 'DD MMM, YYYY');
      this.clientData.interview = this.formatDate(clientInfo.interviewDate, 'MMMM D, YYYY H:mm A');
      this.clientData.age = clientInfo.age;
      this.clientData.type = (clientInfo.type !== '') ? clientInfo.type : clientInfo.leadType;
      this.clientData.city = clientInfo.city;
      this.clientData.departmentID = clientInfo.departmentID;
      this.clientData.leadType = clientInfo.leadType;
      this.clientData.state = clientInfo.state;
      this.clientData.country = clientInfo.country || 'USA';
      this.clientData.postalCode = clientInfo.postalCode;
      this.clientData.createdBy = clientInfo.createdBy;
      this.clientData.insuranceLicense = clientInfo.isLicensed;
      this.clientData.markerColor = clientInfo.markerColor || 'red';
      this.clientData.lastVisitDate = clientInfo.lastVisitDate ? this.formatDate(clientInfo.lastVisitDate, 'MMM DD, YYYY') : 'Never';
    },
    async updateListClientCoordinates(extra = {}) {
      this.isLoading = true;

      // ... TODO tu validación actual (keyword, etc) igual
      let typeAhead = document.getElementById('typeahead_id');

      const data = {
        token: localStorage.getItem('jwt'),
        isProspect: window.location.href.match('/prospects/') ? 1 : 0,
        searchValues: this.searchValues,
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
        deleted: 0,
        agentSearch: (typeAhead != null && typeof typeAhead != 'undefined') ? typeAhead.value : [],
        // ✅ aquí van bounds y zoom
        ...extra,
      };

      try {
        const res = await axios.post('/api/client/listClientCoordinates', data);

        const newMarkers = [];
        if (!this.iconCache) this.iconCache = {};
        
        res.data.forEach(item => {
          const lat = parseFloat(item.lat);
          const lng = parseFloat(item.lng);
          const isCluster = !!item.isCluster;
          const count = item.count;
          const markerColor = item.markerColor || 'red';
          
          let options;
          if (isCluster) {
            options = {
                position: { lat, lng },
                label: { text: String(count), fontWeight: 'bold' }
            };
          } else {
            if (!this.iconCache[markerColor]) {
               this.iconCache[markerColor] = this.getPinIcon(markerColor);
            }
            options = {
                position: { lat, lng },
                icon: this.iconCache[markerColor],
                label: null,   // source label is shown only on hover (markerOptions)
            };
          }

          newMarkers.push(Object.freeze({
            id: item.ID || `${lat}-${lng}-${count || 0}`,
            lat: lat,
            lng: lng,
            title: item.title,
            address: item.address,
            phone: item.phoneNumber,
            source: item.source || '',
            count: count,
            isCluster: isCluster,
            markerColor: markerColor,
            options: options
          }));
        });
        this.markers = Object.freeze(newMarkers);
      } catch (error) {
        // tu manejo de errores igual
      } finally {
        this.isLoading = false;
      }
    },
    voidPostalCodeMessage() {
      Swal.fire("Please write your Zip Code, bigger than 4 digits or select Status/Source", '', 'info');
    },
    async markVisitPending(id) {
      const result = await Swal.fire({
        title: 'Mark as Visited \u2013 No Response?',
        text: "Are you sure you want to mark this visit as visited \u2013 no response?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fd7e14',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, Mark Visited \u2013 No Response'
      });

      if (!result.isConfirmed) return;

      try {
        const res = await axios.post('/api/client/markVisitPending', {
          token: localStorage.getItem('jwt'),
          clientID: id,
          userEmail: localStorage.getItem('email')
        });
        if (res.data.success) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          });
          Toast.fire({ icon: 'success', title: 'Marked as Visited \u2013 No Response' });
          this.selectedMarker = null; // hide InfoWindow to avoid stale data
          
          // update open client form data if it's open
          if (this.clientData && this.clientData.ID == id) {
             this.clientData.markerColor = 'orange';
          }
          
          this.updateListClientCoordinates(this.getViewportExtra()); // reload map markers
        } else {
          // If server returns false or success=false
          Swal.fire("Error", res.data.error || "Could not mark as Visited \u2013 No Response", "error");
        }
      } catch (err) {
        Swal.fire("Error", "Server error", "error");
      }
    },
    async markVisited(id) {
      const result = await Swal.fire({
        title: 'Mark as Visited?',
        text: "Are you sure you want to mark this location as visited today?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, mark it!'
      });

      if (!result.isConfirmed) return;

      try {
        const res = await axios.post('/api/client/markVisited', {
          token: localStorage.getItem('jwt'),
          clientID: id,
          userEmail: localStorage.getItem('email')
        });
        if (res.data.success) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          });
          Toast.fire({ icon: 'success', title: 'Marked as visited' });
          this.selectedMarker = null; // hide InfoWindow to avoid stale data
          
          // update open client form data if it's open
          if (this.clientData && this.clientData.ID == id) {
             this.clientData.markerColor = 'green';
             this.clientData.lastVisitDate = this.formatDate(new Date(), 'MMM DD, YYYY');
          }
          
          this.updateListClientCoordinates(this.getViewportExtra()); // reload map markers
        } else {
          Swal.fire("Error", res.data.error || "Could not mark as visited", "error");
        }
      } catch (err) {
        Swal.fire("Error", "Server error", "error");
      }
    },
    async updateStatus() {

      let typeAhead = document.getElementById('typeahead_id')
      let data = {
        token: localStorage.getItem('jwt'),
        searchValues: this.searchValues,
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
        isProspect: this.searchValues.isProspect,
        deleted: 0,
        agentSearch: (typeAhead != null && typeof (typeAhead) != 'undefined') ? typeAhead.value : []
      }
      await axios
          .post('/api/client/clientStatus', data)
          .then(response => {
            this.statusList = response.data
          })
          .catch(error => {
            if (error.response) {

              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }

              Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
            }
          })
    },
    checkValueArray(needle, arr) {
      return needle in arr
          ? arr[needle]
          : null;
    },
    async searchAgents() {
      let typeAhead = document.getElementById('typeahead_id')

      const data = {
        token: localStorage.getItem('jwt'),
        searchValue: (typeAhead != null && typeof (typeAhead) != 'undefined') ? typeAhead.value : [],
        condition: 9
      }

      if (data['searchValue'].length > 3) {
        await axios
            .post('/api/userFinder', data)
            .then(async response => {
              this.itemsSearch = response.data;
            })
            .catch(async error => {
              if (error.response) {
                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      }


    },
    async handleStatus() {
      window.location.href.match('/prospects/') ? this.sortingStatus = [
            {value: '0', label: 'All'},
            {value: '1', label: 'New lead'},
            {value: '3', label: 'Lost deal'},
            {value: '4', label: 'Follow up'},
            {value: '5', label: 'Closed'},
            {value: '9', label: 'Appointment'},
            {value: '10', label: 'Reschedule'},
            {value: '12', label: 'Visited \u2013 No Response'}
          ]
          : this.sortingStatus = [
            {value: '0', label: 'All'},
            {value: '2', label: 'Appointment'},
            {value: '6', label: 'Cust Service'},
            {value: '7', label: 'Increase Policy'},
            {value: '8', label: 'Cancelled'},
            {value: '11', label: 'Client'}
          ]
    },
    selectMarker(m) {
      this.selectedCluster = null;
      this.selectedMarker = m;
    },
    // Keep a non-reactive registry of the Marker components so we can toggle a
    // pin's label imperatively on hover. Driving the label through reactive
    // state instead makes MarkerCluster rebuild every marker on each hover,
    // which flickers the whole map.
    setMarkerRef(id, el) {
      if (!this.markerRefs) this.markerRefs = {};
      if (el) this.markerRefs[id] = el;
      else delete this.markerRefs[id];
    },
    googleMarker(id) {
      const cmp = this.markerRefs && this.markerRefs[id];
      return cmp ? cmp.marker : null; // google.maps.Marker instance (exposed)
    },
    onMarkerOver(m) {
      if (!m.source || m.isCluster) return;
      const gm = this.googleMarker(m.id);
      if (gm) {
        gm.setLabel({
          text: String(m.source),
          className: 'marker-source-label',
          color: '#2c3e50',
          fontSize: '11px',
          fontWeight: '600',
        });
      }
    },
    onMarkerOut(m) {
      const gm = this.googleMarker(m.id);
      if (gm) gm.setLabel(null);
    },
    selectCluster(c) {
      this.selectedMarker = null;
      // si NO quieres InfoWindow de cluster:
      this.selectedCluster = null;

      // lo ideal: zoom para revelar clientes
      this.zoomIntoCluster(c);
    },
    zoomIntoCluster(c) {
      const ref = this.$refs.mapRef;
      const map = ref && (ref.map || ref.$mapObject || ref.googleMap);
      if (!map) return;

      map.panTo({ lat: c.lat, lng: c.lng });
      map.setZoom((map.getZoom() || 10) + 2);
    },
    // opcional: pedir al backend “los puntos dentro del cluster”
    // (si quieres que "View list" muestre esos clientes)
    async loadClusterList(c) {
      await this.updateListClientCoordinates({
        bounds: c.bounds, // si luego mandas bounds del cluster desde backend
        zoom: (this.zoom || 12) + 2
      });
    },
    onMapIdle() {
      clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(async () => {
        const ref = this.$refs.mapRef;
        const map = ref && (ref.map || ref.$mapObject || ref.googleMap);
        if (!map) return;

        const b = map.getBounds();
        if (!b) return;

        const ne = b.getNorthEast();
        const sw = b.getSouthWest();
        const zoom = map.getZoom();
        this.zoom = zoom;

        await this.updateListClientCoordinates({
          bounds: { ne: { lat: ne.lat(), lng: ne.lng() }, sw: { lat: sw.lat(), lng: sw.lng() } },
          zoom
        });
      }, 1250);
    },
    getViewportExtra() {
      const ref = this.$refs.mapRef;
      const map = ref && (ref.map || ref.$mapObject || ref.googleMap);
      if (!map) return {};

      const b = map.getBounds();
      if (!b) return {};

      const ne = b.getNorthEast();
      const sw = b.getSouthWest();

      return {
        bounds: { ne: { lat: ne.lat(), lng: ne.lng() }, sw: { lat: sw.lat(), lng: sw.lng() } },
        zoom: map.getZoom(),
      };
    },
    zoomToCluster(c) {
      const ref = this.$refs.mapRef;
      const map = ref && (ref.map || ref.$mapObject || ref.googleMap);
      if (!map) return;

      map.panTo({ lat: c.lat, lng: c.lng });
      map.setZoom((map.getZoom() || 10) + 2);
    },
    validPhone: function (phone) {
      var isphone = /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm.test(phone);
      return isphone;
    },
    async updateClient() {

      this.errors = []

      if (!this.clientData.lastName) {
        this.errors.push('Last Name is required.');
      }
      if (!this.clientData.gender) {
        this.errors.push('Gender is required.');
      }

      if (!this.clientData.language) {
        this.errors.push('Language is required.');
      }

      if (!this.clientData.status) {
        this.errors.push('Status is required.');
      }

      if (!this.clientData.phoneNumber) {
        this.errors.push('Phone is required.');
      }

      if (this.validPhone(this.clientData.phoneNumber) === false && this.clientData.phoneNumber !== '') {
        this.errors.push('Please, write a valid phone number!');
      }

      if (!this.clientData.departmentID) {
        this.errors.push('Department is required.');
      }

      if (!this.errors.length) {

        const data = {
          username: '',
          email: this.clientData.email,
          city: this.clientData.city,
          firstName: this.clientData.firstName,
          lastName: this.clientData.lastName,
          language: this.clientData.language,
          status: this.clientData.status,
          leadType: this.clientData.leadType,
          gender: this.clientData.gender,
          phoneNumber: this.clientData.phoneNumber,
          departmentID: this.clientData.departmentID,
          state: this.clientData.state,
          birthDate: this.formatDate(this.clientData.birthday, 'DD MMM, YYYY'),
          address: this.clientData.address,
          country: 'USA',
          postalCode: this.clientData.postalCode,
          interviewDate: this.clientData.interview,
          createdBy: localStorage.getItem('email'),
          licenseNumber: this.clientData.licenseNumber,
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('id'),
          clientID: localStorage.getItem('selectedUser')
        }

        await axios
            .put('/api/client/updateClient', data)
            .then(async response => {
              if (response) {
                document.getElementById('close-modal').click();
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: (this.searchValues.isProspect ? 'Prospect' : 'Client') + ' updated successfully!'
                });
              }
            })
            .catch(async error => {
              if (error.response) {

                if(error.response.data.detail === 'Your session is expired!'){
                  this.$router.push('logout')
                }

                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },
    clearDates() {
      this.searchValues.fromDate = null
      this.searchValues.toDate = null
    },
    calculateMapHeight() {
      this.$nextTick(() => {
        const mapRef = this.$refs.mapRef;
        const mapElement = mapRef ? (mapRef.$el || mapRef) : null;
        if (mapElement && typeof mapElement.getBoundingClientRect === 'function') {
          const rect = mapElement.getBoundingClientRect();
          const footerHeight = 60; // Height of the footer + padding
          const remaining = window.innerHeight - rect.top - footerHeight;
          this.mapHeight = Math.max(400, remaining) + 'px';
        } else {
          this.mapHeight = Math.max(400, window.innerHeight - 300) + 'px';
        }
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateMapHeight);
  },
  async mounted() {

    setInterval(() =>{
      if (window.location.href.match('/prospects/')){
        if (this.searchValues.isProspect !== 1){
          this.isProspect= 1
          this.searchValues.isProspect= 1
          this.updateStatus()
          this.markers = []
          this.searchValues.postalCode = ''
        }
      }else{
        if (this.searchValues.isProspect !== 0){
          this.isProspect= 0
          this.searchValues.isProspect= 0
          this.updateStatus()
          this.markers = []
          this.searchValues.postalCode = ''
        }
      }
      this.title =  this.searchValues.isProspect === 1 ? 'Google Maps | PROSPECTS' : 'Google Maps | CLIENTS';
      this.handleStatus()
    }, 3000);

    this.getCurrentLocation()
    let typeAhead = document.getElementById('typeahead_id')

    let data = {
      token: localStorage.getItem('jwt'),
      searchValues: this.searchValues,
      userEmail: localStorage.getItem('email'),
      userID: localStorage.getItem('id'),
      isProspect: window.location.href.match('/prospects/') ? 1 : 0,
      deleted: 0,
      agentSearch: (typeAhead != null && typeof(typeAhead) != 'undefined' ) ? typeAhead.value : []
    }

    setInterval(data.isProspect= window.location.href.match('/prospects/') ? 1 : 0 , 3000);
    await axios
        .post('/api/listDepartments', data)
        .then(response => {
          this.departmentList=response.data
        })
        .catch(error => {
          if (error.response) {
            if(error.response.data.detail === 'Your session is expired!'){
              this.$router.push('logout')
            }
            Swal.fire("Oops!", "Departments could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    await axios
        .post('/api/client/clientStatus', data)
        .then(response => {
          this.statusList=response.data
        })
        .catch(error => {
          if (error.response) {

            if(error.response.data.detail === 'Your session is expired!'){
              this.$router.push('logout')
            }

            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    await axios
        .post('/api/client/clientTypes', data)
        .then(response => {
          this.typeList = response.data
          this.sortingSource = [
            { value: '0', label: 'All' },
            ...response.data.map(t => ({ value: t.name, label: t.name }))
          ];
        })
        .catch(error => {
          if (error.response) {

            if(error.response.data.detail === 'Your session is expired!'){
              this.$router.push('logout')
            }

            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    const loader = document.getElementById("loader");

    setTimeout(function() {
      loader.style.opacity = 0; // Fade out the loader
      document.body.classList.remove("loading"); // Remove the loading class from body
    }, 5500); // Adjust the delay as needed (in milliseconds)

    // await this.updateListClientCoordinates();
    window.addEventListener('resize', this.calculateMapHeight);
    this.calculateMapHeight();
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <loader v-if="isLoading" :isLoading="isLoading" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card" id="leadsList">
              <div class="card-body border border-dashed border-end-0 border-start-0" >
                <form>
                  <div class="row g-3">
                    <div class="col-xxl-3 col-sm-3">
                      <div class="search-box">
                        <input
                            type="text"
                            class="form-control search"
                            placeholder="Search for..."
                            v-model="searchValues.keyword"
                            v-on:keyup.enter="searchValues.postalCode.length >= 4 || searchValues.leadType !== '0' || searchValues.status !== '0' ? updateListClientCoordinates(getViewportExtra()): updateListClientCoordinates(getViewportExtra())"
                        />
                        <i class="ri-search-line search-icon"></i>
                      </div>
                    </div>
                    <!--end col-->
                    <div class="col-xxl-2 col-sm-6">
                      <div>
                        <div class="input-group">
                          <input type="text"
                                 id="filterPostalCode"
                                 name="filterPostalCode"
                                 class="form-control search"
                                 placeholder="Enter Zip Code"
                                 v-model="searchValues.postalCode">
                          <button class="btn btn-outline-primary" type="button"
                                  id="button-addon2"
                                  @click="searchValues.postalCode.length >= 4 || searchValues.leadType !== '0' || searchValues.status !== '0' ? updateListClientCoordinates(getViewportExtra()): updateListClientCoordinates(getViewportExtra())"
                          >Search</button>
                        </div>
                      </div>
                    </div>
                    <!--end col-->
                    <div class="col-xxl-2 col-sm-2" style="margin-bottom: 5px;">
                      <div class="d-flex align-items-center gap-2">
                        <span class="text-muted flex-shrink-0">Status: </span>

                        <Multiselect class="form-control"
                                     style="padding: 0px;"
                                     autocomplete="off"
                                     v-model="searchValues.status"
                                     :close-on-select="true"
                                     :searchable="true"
                                     :options="sortingStatus"
                                     @update:modelValue="$nextTick(() => updateListClientCoordinates(getViewportExtra()))"

                        />
                      </div>
                    </div>
                    <div class="col-xxl-2 col-sm-2" style="margin-bottom: 5px;">
                      <div class="d-flex align-items-center gap-2">
                        <span class="text-muted flex-shrink-0">Source: </span>

                        <Multiselect class="form-control"
                                     style="padding: 0px;"
                                     v-model="searchValues.leadType"
                                     autocomplete="off"
                                     :close-on-select="false"
                                     :searchable="true"
                                     :options="sortingSource"
                                     :mode="'tags'"
                                     @update:modelValue="$nextTick(() => updateListClientCoordinates(getViewportExtra()))"
                        />

                      </div>
                    </div>
                    <div class="col-xxl-2 col-sm-2" style="margin-bottom: 5px;">
                      <div class="d-flex align-items-center gap-2">
                        <span class="text-muted flex-shrink-0">Visit Status: </span>

                        <Multiselect class="form-control"
                                     style="padding: 0px;"
                                     v-model="searchValues.visitStatus"
                                     autocomplete="off"
                                     :close-on-select="true"
                                     :searchable="false"
                                     :options="sortingVisitStatus"
                                     @update:modelValue="$nextTick(() => updateListClientCoordinates(getViewportExtra()))"
                        >
                          <template v-slot:singlelabel="{ value }">
                            <div class="multiselect-single-label">
                              <span v-if="value.value !== '0'" class="mdi mdi-checkbox-blank-circle align-middle me-1" :class="{ 'text-success': value.value === 'green', 'text-warning': value.value === 'yellow', 'text-danger': value.value === 'red' }"></span>
                              {{ value.label }}
                            </div>
                          </template>
                          <template v-slot:option="{ option }">
                            <div class="w-100">
                              <span v-if="option.value !== '0'" class="mdi mdi-checkbox-blank-circle align-middle me-1" :class="{ 'text-success': option.value === 'green', 'text-warning': option.value === 'yellow', 'text-danger': option.value === 'red' }"></span>
                              {{ option.label }}
                            </div>
                          </template>
                        </Multiselect>
                      </div>
                    </div>
                    <!--end col-->
                    <div class="col-xxl-1 col-sm-4">
                      <button type="button" class="btn btn-soft-success float-end" href="#open-filters" data-bs-toggle="modal">
                        <i class="ri-filter-line align-bottom me-1"></i> Filters
                      </button>
                    </div>
                    <!--end col-->
                  </div>
                  <!--end row-->
                </form>
              </div>
            </div>
            <GoogleMap
                api-key="AIzaSyBJXnhtk3_2A9SN4ExKh0m9UBlEJk3hsCU"
                ref="mapRef"
                :center="center || { lat: 29.782962, lng: -95.6693004 }"
                :zoom="zoom"
                @idle="onMapIdle"
                :style="{ width: '100%', height: mapHeight }"
            >
              <!-- PUNTOS -->
              <MarkerCluster>
                <Marker
                    v-for="m in rawMarkers"
                    :key="m.id"
                    :ref="el => setMarkerRef(m.id, el)"
                    :options="m.options"
                    @mouseover="onMarkerOver(m)"
                    @mouseout="onMarkerOut(m)"
                    @click="selectMarker(m)"
                />
              </MarkerCluster>

              <!-- CLUSTERS (solo para hacer zoom) -->
              <Marker
                  v-for="c in clusterMarkers"
                  :key="'cluster-' + c.id"
                  :options="c.options"
                  @click="selectCluster(c)"
              />

              <Marker
                  v-if="center"
                  :options="{
                    position: center,
                    title: 'My Location',
                    icon: 'http://university.dmbgroup.online/wp-content/uploads/2025/07/51186b5bf7e78bc19b2c2d035e39e95e_210004-15-1111-1-e1751584281435.png'
                  }"

              />
              <!-- ✅ InfoWindow CLIENTE -->
              <InfoWindow
                  v-if="selectedMarker && !selectedMarker.isCluster"
                  :options="{
                        position: { lat: selectedMarker.lat, lng: selectedMarker.lng },
                        disableAutoPan: true
                  }"
                  @closeclick="selectedMarker = null"
              >
                <div id="content">
                  <div class="header-badges">
                    <span v-if="selectedMarker.source" class="source-badge">{{ selectedMarker.source }}</span>
                    <span v-if="selectedMarker.markerColor === 'green'" class="badge bg-success ms-2 visit-badge" title="Visited Recently">🟢 Visited Recently</span>
                    <span v-else-if="selectedMarker.markerColor === 'yellow'" class="badge bg-warning text-dark ms-2 visit-badge" title="Needs Follow-up">🟡 Follow-up Needed</span>
                    <span v-else-if="selectedMarker.markerColor === 'red' || !selectedMarker.markerColor" class="badge bg-danger ms-2 visit-badge" title="Overdue / Never">🔴 Overdue / Never</span>
                  </div>
                  <h1 id="firstHeading" class="firstHeading" style="margin-top: 32px;">{{ selectedMarker.title }}</h1>

                  <div id="bodyContent">
                    <p>
                      <b>Address:</b> {{ selectedMarker.address }}
                      <br>
                      <b>Phone:</b>
                      <a :href="'tel:'+selectedMarker.phone" style="line-height:1.5;color:#7f8c8d;">
                        {{ selectedMarker.phone }}
                      </a>
                      <br>
                      <a
                          :href="'https://maps.google.com/?q='+encodeURIComponent(selectedMarker.address)"
                          target="_blank"
                          style="line-height:1.5;color:#25a0e2;"
                      >
                        View On Google Maps
                      </a>
                    </p>

                    <!-- Si NO quieres depender de BListGroupItem/Icons, usa botones simples -->
                    <div class="info-actions">
                      <a class="btn btn-dark btn-sm" :href="'tel:'+selectedMarker.phone">
                        Call
                      </a>

                      <button
                          class="btn btn-dark btn-sm"
                          @click="getClientInfo(selectedMarker.id)"
                          data-bs-toggle="modal"
                          data-bs-target="#clientModal"
                      >
                        View
                      </button>

                      <!-- Mark Visited and Mark Pending removed to force users into the form -->
                    </div>
                  </div>
                </div>
              </InfoWindow>


              <!-- ✅ InfoWindow cliente (si quieres, agrégalo después) -->
            </GoogleMap>
          </div>
        </div>
      </div>
    </div>

    <!-- Filters Modal -->
    <div id="open-filters" class="modal fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;" data-bs-focus="false">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Filters</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-6">
                <label for="filterKeyword" class="form-label">Keyword</label>
                <input type="text" id="filterKeyword" name="filterKeyword" class="form-control mb-2" placeholder="Enter Keyword" v-model="searchValues.keyword">
              </div>
              <div class="col-lg-6">
                <label for="filterPostalCode" class="form-label">Zip Code</label>
                <input type="text"
                       id="filterPostalCode"
                       name="filterPostalCode"
                       class="form-control search"
                       placeholder="Enter Zip Code"
                       v-model="searchValues.postalCode">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label for="filterFromDate" class="form-label"> From date </label>
                <flat-pickr
                    v-model="searchValues.fromDate"
                    :config="humanfriendlyConfigDates"
                    class="form-control flatpickr-input"
                    id="filterFromDate"
                    name="filterFromDate"
                ></flat-pickr>
              </div>
              <div class="col-lg-6">
                <label for="filterToDate" class="form-label"> To Date </label>
                <flat-pickr
                    v-model="searchValues.toDate"
                    :config="humanfriendlyConfigDates"
                    class="form-control flatpickr-input"
                    id="filterToDate"
                    name="filterToDate"
                ></flat-pickr>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label for="filterType" class="form-label">Source</label>
                <Multiselect class="form-control"
                             style="padding: 0px;"
                             v-model="searchValues.leadType"
                             autocomplete="off"
                             :close-on-select="false"
                             :searchable="true"
                             :options="sortingSource"
                             :mode="'tags'"
                />
              </div>
              <div class="col-lg-6">
                <label for="filterStatus" class="form-label">Status</label>
                <select class="form-select mb-2" aria-label="Status" id="filterStatus" v-model="searchValues.status">
                  <option value="0">All</option>
                  <option v-for="(status, statusIndex) of statusList" :key="statusIndex" v-bind:value="status.statusID">{{ status.name }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label for="editLanguage" class="form-label">Language</label>
                <select class="form-select mb-2" aria-label="Language" id="filterLanguage" name="filterLanguage" v-model="searchValues.language">
                  <option value="1">English</option>
                  <option value="2">Spanish</option>
                  <option value="3">Both</option>
                </select>
              </div>
              <div class="col-lg-6">
                <span v-if="viewUserGroup('SUPER_ADMIN_GROUP')">
                  <label for="filterDateRange" class="form-label">Department</label>
                    <select class="form-select mb-2" aria-label="Department" id="filterDepartment" name="filterDepartment"
                            v-model="searchValues.department">
                        <option value="0"> All</option>
                        <option v-for="(department, index) of departmentList"  :key="index"
                                v-bind:value="department.departmentID"> {{ department.name }}
                        </option>
                    </select>
              </span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
              </div>
              <div class="col-lg-6">
              </div>
            </div>
            <div class="row">

            </div>
            <div class="row">
              <div class="col-lg-6">
              </div>
              <div class="col-lg-6">
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" v-if="viewUserGroup('SUPER_ADMIN_GROUP') || viewUserGroup('ADMIN_GROUP')">
                <label for="typeahead_id" class="form-label">Find By Agent</label>
                <SimpleTypeahead
                    id="typeahead_id"
                    placeholder="Type your agent search..."
                    :items="itemsSearch"
                    :minInputLength="3"
                    :class="'form-control mb-2'"
                    @onInput="searchAgents"
                >
                </SimpleTypeahead>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="updateListClientCoordinates(getViewportExtra())">Search</button>
            <button class="btn btn-sm btn-light" @click="clearDates">
              Clear dates
            </button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <!--  Add client modal  -->
    <div class="modal zoomIn" id="clientModal" tabindex="-1" aria-labelledby="agentModalLabel" aria-hidden="true" data-bs-focus="false">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 1000px;">
        <div class="modal-content">
          <div class="modal-header bg-light p-3">
            <h5 class="modal-title d-flex align-items-center" id="agentModalLabel">
               {{ modalFormTitle }}
               <template v-if="clientData.markerColor">
                 <div class="dropdown d-inline-block ms-2">
                   <span v-if="clientData.markerColor === 'green'" class="badge bg-success dropdown-toggle" data-bs-toggle="dropdown" style="cursor: pointer;" title="Visited Recently">🟢 Visited Recently</span>
                   <span v-else-if="clientData.markerColor === 'orange'" class="badge dropdown-toggle" data-bs-toggle="dropdown" style="cursor: pointer; background-color: #fd7e14; color: white;" title="Visited &ndash; No Response">🟠 Visited &ndash; No Response</span>
                   <span v-else-if="clientData.markerColor === 'yellow'" class="badge bg-warning text-dark dropdown-toggle" data-bs-toggle="dropdown" style="cursor: pointer;" title="Needs Follow-up">🟡 Needs Follow-up</span>
                   <span v-else-if="clientData.markerColor === 'red' && (!clientData.lastVisitDate || clientData.lastVisitDate === 'Never')" class="badge bg-danger dropdown-toggle" data-bs-toggle="dropdown" style="cursor: pointer;" title="Never Visited">🔴 Never Visited</span>
                   <span v-else-if="clientData.markerColor === 'red'" class="badge bg-danger dropdown-toggle" data-bs-toggle="dropdown" style="cursor: pointer;" title="Visit Overdue">🔴 Visit Overdue</span>
                   
                   <ul class="dropdown-menu">
                     <li v-if="clientData.markerColor !== 'green'"><a class="dropdown-item" href="#" @click.prevent="markVisited(clientData.ID)">🟢 Mark Visited</a></li>
                     <li v-if="clientData.markerColor !== 'orange'"><a class="dropdown-item" href="#" @click.prevent="markVisitPending(clientData.ID)">🟠 Mark Visited &ndash; No Response</a></li>
                   </ul>
                 </div>
               </template>
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    id="close-modal"></button>
          </div>
          <form id="addform" @submit.prevent="" autocomplete="off">
            <div class="modal-body">
              <h6> <span style="color:red; font-size: 0.7em;">Required fields (*)</span></h6>
              <input type="hidden" id="id"/>
              <div class="row g-3">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-7">
                      <label for="editEmail" class="form-label">Email</label>
                      <input type="text" id="editEmail" name="editEmail" class="form-control mb-2 createEmail" placeholder="Enter Email"
                             v-model="clientData.email" autocomplete="off">
                      <div class="invalid-feedback">
                        This email is already in use.
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <label for="editCreatedBy" class="form-label">Created By</label>
                      <input type="text" id="editCreatedBy" name="editCreatedBy" class="form-control mb-2" disabled v-model="clientData.createdBy"  autocomplete="off">
                    </div>
                    <div class="col-lg-2">
                      <label for="lastVisitDate" class="form-label">Last Visit</label>
                      <input type="text" id="lastVisitDate" class="form-control mb-2" disabled v-model="clientData.lastVisitDate" autocomplete="off">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <label for="editFirstName" class="form-label">First Name <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <input type="text" id="editFirstName" name="editFirstName" class="form-control mb-2" placeholder="Enter First Name" v-model="clientData.firstName" required  autocomplete="off">
                    </div>
                    <div class="col-lg-4">
                      <label for="editLastName" class="form-label">Last Name <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <input type="text" id="editLastName" name="editLastName" class="form-control mb-2" placeholder="Enter Last Name" v-model="clientData.lastName" required  autocomplete="off">
                    </div>
                    <div class="col-lg-4">
                      <label for="editGender" class="form-label"> Gender <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <br>
                      <div class="form-check-success form-check-inline" style="margin-top: 0.8em;">
                        <input class="form-check-input" type="radio" name="editGender" id="editGender" value="M" v-model="clientData.gender"/>
                        <label class="form-check-label" for="editGender"> &nbsp; Male</label>
                      </div>
                      <div class="form-check-success form-check-inline" style="margin-top: 0.8em;">
                        <input class="form-check-input" type="radio" name="editGender" id="editGender2" value="F" v-model="clientData.gender"/>
                        <label class="form-check-label" for="editGender2"> &nbsp; Female</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <label for="editLanguage" class="form-label">Language <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Language" id="editLanguage" name="editLanguage" v-model="clientData.language" required>
                        <option value="1" selected>English</option>
                        <option value="2">Spanish</option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label for="editStatus" class="form-label">Status <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Status" id="editStatus" name="editStatus" v-model="clientData.status">
                        <option v-for="(status, statusIndex) of statusList" :key="statusIndex" v-bind:value="status.statusID">{{ status.name }}</option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label for="editType" class="form-label">client Source <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Status" id="editType" name="editType" v-model="clientData.leadType">
                        <option v-for="(type, typeIndex) of typeList" :key="typeIndex" v-bind:value="type.name">{{ type.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <label for="editPhoneNumber" class="form-label">Phone <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <input type="text" id="editPhoneNumber" name="editPhoneNumber" class="form-control mb-2" placeholder="Phone number" required v-model="clientData.phoneNumber"/>
                    </div>
                    <div class="col-lg-4">
                      <label for="editDepartment" class="form-label">Department <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Department" id="editDepartment" name="editDepartment"
                              v-model="clientData.departmentID" v-if="(departmentList.length > 1)">
                        <option v-for="(department, index) of departmentList"  :key="index"
                                v-bind:value="department.departmentID">{{ department.name }}
                        </option>
                      </select>
                      <select class="form-select mb-2" aria-label="Department" id="editDepartment" name="editDepartment"
                              v-model="clientData.departmentID" v-else>
                        <option v-bind:value="departmentList.departmentID">{{ departmentList.name }}</option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label for="editInterview" class="form-label mb-2">Interview</label>
                      <flat-pickr
                          v-model="clientData.interview"
                          :config="dateTimeConfig"
                          id="editInterview"
                          name="editInterview"
                          class="form-control"
                          data-provider="timepickr"
                          data-time-hrs="true"
                      ></flat-pickr>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-8">
                      <label for="editAddress" class="form-label">Address</label>&nbsp;<code><a href="#" target="_blank" id="gMapsLink">Google Maps </a></code>
                      <input type="text" id="editAddress" name="editAddress" class="form-control mb-2" placeholder="Enter Address" required v-model="clientData.address"/>
                    </div>
                    <div class="col-lg-4">
                      <label for="editBirthdate" class="form-label"> Birthdate </label>
                      <flat-pickr
                          v-model="clientData.birthday"
                          :config="timeConfig"
                          class="form-control flatpickr-input"
                          id="editBirthdate"
                          name="editBirthdate"
                      ></flat-pickr>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3">
                      <label for="editState" class="form-label">State</label>
                      <input type="text" id="editState" name="editState" class="form-control mb-2" placeholder="Enter State" required v-model="clientData.state"/>
                    </div>
                    <div class="col-lg-5">
                      <label for="editCity" class="form-label">City</label>
                      <input type="text" id="editCity" name="editCity" class="form-control mb-2" placeholder="Enter City" required v-model="clientData.city"/>
                    </div>
                    <div class="col-lg-4">
                      <label for="editPostalCode" class="form-label">Zip code</label>
                      <input type="text" id="editPostalCode" name="editPostalCode" class="form-control mb-2" placeholder="Enter Address" required v-model="clientData.postalCode"/>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-12" style="margin-top: 10px;">
                      <div class="card">
                        <div class="card-body checkout-tab">
                          <form action="#">
                            <div class="step-arrow-nav mt-n3 mx-n3 mb-3">
                              <ul class="nav nav-pills nav-justified custom-nav" role="tablist">
                                <li class="nav-item" role="presentation">
                                  <button
                                      class="nav-link fs-15 p-3 active"
                                      id="pills-bill-notes-tab"
                                      data-bs-toggle="pill"
                                      data-bs-target="#pills-pills-notes"
                                      type="button"
                                      role="tab"
                                      aria-controls="pills-pills-notes"
                                      aria-selected="true"
                                  >
                                    <i
                                        class="
                                      ri-sticky-note-line
                                      fs-16
                                      p-2
                                      bg-soft-primary
                                      text-primary
                                      rounded-circle
                                      align-middle
                                      me-2
                                    "
                                    ></i>
                                    Notes
                                  </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                  <button
                                      class="nav-link fs-15 p-3 disabled"
                                      id="pills-econtact"
                                      data-bs-toggle="pill"
                                      data-bs-target="#pills-econtact-tab"
                                      type="button"
                                      role="tab"
                                      aria-controls="pills-econtact-tab"
                                      aria-selected="false"
                                  >
                                    <i
                                        class="
                        ri-alarm-warning-line
                        fs-16
                        p-2
                        bg-soft-primary
                        text-primary
                        rounded-circle
                        align-middle
                        me-2
                      "
                                    ></i>
                                    E. Contacts (disabled)
                                  </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                  <button
                                      class="nav-link fs-15 p-3 disabled"
                                      id="pills-payment-tab"
                                      data-bs-toggle="pill"
                                      data-bs-target="#pills-payment"
                                      type="button"
                                      role="tab"
                                      aria-controls="pills-payment"
                                      aria-selected="false"
                                  >
                                    <i
                                        class="
                                              ri-folder-upload-line
                                              fs-16
                                              p-2
                                              bg-soft-primary
                                              text-primary
                                              rounded-circle
                                              align-middle
                                              me-2
                                            "
                                    ></i>
                                    Upload Files (disabled)
                                  </button>
                                </li>
                              </ul>
                            </div>

                            <div class="tab-content">
                              <div
                                  class="tab-pane fade show active"
                                  id="pills-pills-notes"
                                  role="tabpanel"
                                  aria-labelledby="pills-notes"
                              >
                                <div>
                                  <div class="row" id="editNoteOpen">
                                    <notes :dataList="notesData" @onFire="getNotes()" :idNumber="1"> </notes>
                                  </div>
                                </div>
                              </div>
                              <!-- end tab pane -->

                              <div
                                  class="tab-pane fade"
                                  id="pills-econtact-tab"
                                  role="tabpanel"
                                  aria-labelledby="pills-econtact"
                              >
                              </div>
                              <!-- end tab pane -->

                              <div
                                  class="tab-pane fade"
                                  id="pills-payment"
                                  role="tabpanel"
                                  aria-labelledby="pills-payment-tab"
                              >
                                <div>
                                  <div class="col-12 text-center">
                                    <h1 class="mb-3">Upload Files</h1>
                                    <h6><b>Allowed Files:</b> <p>.jpg, .png, .docx, .xls, .jpeg, .pdf</p></h6>
                                    <h6><b>Max. File Size:</b> <p>5 mb</p></h6>
                                  </div>

                                  <div class="col-md-12">
                                    <form enctype='multipart/form-data'>
                                      <div class="form-group">
                                        <label for="uploadFiles">Select Image</label>
                                      </div>
                                    </form>
                                    <div class="table-responsive" style="margin-top: 20px;">
                                      <button type="button" class="btn btn-soft-success float-end"
                                              style="margin-bottom: 10px;"> Refresh File List </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- end tab pane -->
                            </div>
                            <!-- end tab content -->
                          </form>
                        </div>
                        <!-- end card body -->
                      </div>
                      <!-- end card -->
                    </div>
                    <!-- end col -->
                  </div>
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </div>

            <div class="modal-footer">
              <div class="hstack gap-2 justify-content-end">
                <button type="button" class="btn btn-light" id="closemodal" data-bs-dismiss="modal">Close </button>
                <button type="submit" class="btn btn-success" id="add-btn" @click="createClient">Save </button>
                <button type="button" class="btn btn-success" id="edit-btn" @click="updateClient">Update </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <TrafficLightLegend />
  </Layout>
</template>

<style>
#content {
  margin: 0;
  padding: 10px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
}

#firstHeading.firstHeading {
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 5px;
  text-align: center;
  color: #2c3e50;
}

#bodyContent {
  line-height: 1.5;
  color: #7f8c8d;
}

#bodyContent b {
  color: #2c3e50;
}

#content {
  position: relative;
  margin: 0;
  padding: 32px 16px 16px 16px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  font-family: Arial, sans-serif;
  min-width: 280px;
}

.firstHeading {
  font-size: 1.25em;
  font-weight: 700;
  margin: 0 0 10px 0;
  text-align: center;
  color: #2c3e50;
}

.info-actions{
  display:flex;
  justify-content:center;
  gap:10px;
  margin-top:12px;
}

/* Source label floating in a box just above each pin on the map. */
.marker-source-label {
  background: #fff;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  padding: 1px 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
}

/* Source pinned to the top-left corner of the info window (out of normal flow,
   so the #content top padding keeps the name/body clear of it). */
.header-badges {
  position: absolute;
  top: 8px;
  left: 16px;
  right: 40px;       /* leave room for Google's close (X) button on the right */
  display: flex;
  align-items: center;
}
.source-badge {
  margin: 0;
  text-align: left;
  color: #2c3e50;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
}
.visit-badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
  border-radius: 4px;
}

</style>